import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, slate } from './glowUtil'
import { DOT_PREFIX } from './constant'

const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
const focusGlow = `0 0 0 1px ${cyan[500]}20, 0 0 4px ${cyan[500]}10 !important`

export default genComponentStyleHook(['Select', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-selector`]: {
        borderRadius: '2px !important',
        background: `${slate[900]} !important`,
        borderColor: `${cyan[500]}20 !important`,
        transition,
      },

      '&:hover': {
        [`${componentCls}-selector`]: {
          borderColor: `${cyan[500]}50 !important`,
        },
      },

      [`&${componentCls}-focused`]: {
        [`${componentCls}-selector`]: {
          borderColor: `${cyan[500]}80 !important`,
          boxShadow: focusGlow,
        },
      },

      [`${componentCls}-arrow`]: {
        color: `${cyan[600]} !important`,
      },

      [`${componentCls}-clear`]: {
        background: `${slate[900]} !important`,
        color: `${cyan[600]} !important`,
        '&:hover': {
          color: `${cyan[400]} !important`,
        },
      },
    },
  }
})
